import { Button, Card, Row, SearchInput, Slider } from '@kaleyra/emmy';
import React, { useEffect, useState } from 'react';
import cn from "classnames";
import PlusIcon from "../../../../../../assets/plusIcon.svg";
import Styles from './index.module.scss';
import moment from 'moment';
import UrlShortenerForm from '../../../containers/receive-message/urlShortenerForm';
import { useTranslation } from 'react-i18next';

export type OwnProps = {
    data: any;
    closeOverlaySidebar: () => void;
    showAsOverlaySlider?: boolean;
    _sidebarType: string;
    _getSidebarTyoe: (type: string) => void;
}

export type MapStateType = {
    urlData: any;
};

export type DispatchPropsType = {
    onClose: () => void;
    updateSelectedUrlInStore: (urlId: string) => void;
    updateCreatedUrlInStore: (shortUrl: string) => void;
};

const SelectUrl: React.FC<MapStateType & DispatchPropsType & OwnProps> = ({ onClose, updateSelectedUrlInStore, updateCreatedUrlInStore, urlData, data, closeOverlaySidebar, showAsOverlaySlider, _sidebarType, _getSidebarTyoe }) => {

    const { t } = useTranslation();
    const [selectedUrl, setSelectedUrl] = useState<string>("");
    const [addSliderVisible, setAddSliderVisible] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const [filteredUrlList, setFilteredUrlList] = useState<any>([]);

    useEffect(() => {
        if (data) {
            setFilteredUrlList([...data]);
        }
    }, [data]);

    useEffect(() => {
        if (searchValue !== "") {
            showSearchUrls(searchValue);
        } else {
            data ? setFilteredUrlList(data) : setFilteredUrlList(urlData?.extraParam?.data || []);
        }
    }, [searchValue])

    const handleCloseSidebar = () => {
        if (!showAsOverlaySlider) {
            onClose();
        } else {
            closeOverlaySidebar && closeOverlaySidebar();
        }
    }

    const renderSliderFooter = () => {
        return (
            <Row className={cn(Styles.footerRow, showAsOverlaySlider && Styles.footerPosition)}>
                <Button type="tertiary" onClick={() => handleCloseSidebar()}>{t('mainCancel')}</Button>
                <Button disabled={selectedUrl === ""} onClick={() => handleSaveTemplate()}>{t('mainSave')}</Button>
            </Row>)
    }

    const showSearchUrls = (searchValue: string) => {
        let searchResult;
        if (data) {
            searchResult = data.filter((value: any) => (value.title.toLowerCase()).includes(searchValue.toLowerCase()))
        } else {
            searchResult = (urlData?.extraParam?.data).filter((value: any) => (value.title.toLowerCase()).includes(searchValue.toLowerCase()))
        }
        setFilteredUrlList(searchResult);
    }

    const handleSaveTemplate = () => {
        updateSelectedUrlInStore(selectedUrl);
        if (!showAsOverlaySlider) {
            urlData.extraParam.getSidebarType(urlData.extraParam.type);
            onClose();
        } else {
            _getSidebarTyoe(_sidebarType);
            closeOverlaySidebar && closeOverlaySidebar();
        }
    }

    const handleTemplateSelect = (urlData: any) => {
        setSelectedUrl(urlData.id);
    }

    const renderUrlCard = (urlData: any, index: number) => {
        return (
            <Card className={cn(Styles.templateBody, selectedUrl === urlData.id ? Styles.selectedTemplate : "")} showHoverBorder={false}
                key={`${urlData.id}-${index}`} onClick={() => handleTemplateSelect(urlData)}>
                <Row className={Styles.rowWrapper}>
                    <div className={Styles.templateInfo}>
                        <span>{urlData.title || "-"}</span>
                        <div className={Styles.dateNameContainer}>
                            <span>{urlData.short_url}</span>
                            <span>{moment(urlData.created_at).format("DD MMM YYYY") || "-"}</span>
                        </div>
                    </div>
                </Row>
            </Card>
        )
    }

    const renderSliderBody = () => {
        return (<>
            <div className={Styles.modalContainer}>
                <Row className={Styles.buttonWrapper}>
                    <Button small iconPosition='left' icon={<img width={20} src={PlusIcon} alt="button-icon" />} onClick={() => setAddSliderVisible(true)}>{t('BLD02014')}</Button>
                </Row>
                <SearchInput eachChar className={Styles.searchInput} searchStr={searchValue} onChange={(text: any) => setSearchValue(text)} />
                {filteredUrlList.length ?
                    filteredUrlList.map((templateData: any, index: number) => renderUrlCard(templateData, index))
                    :
                    <div className={Styles.noData}>
                        <span>{t('noUrlMessage')}</span>
                    </div>}
            </div>
            {
                showAsOverlaySlider && renderSliderFooter()
            }
        </>
        )
    }

    return (
        <>
            {!showAsOverlaySlider ?
                <Slider
                    footer={renderSliderFooter()}
                    visibility={true}
                    containerId={'root-modal'}
                    onClose={() => onClose()}
                    title={t('KLR03039')}>
                    {renderSliderBody()}
                </Slider> :
                <>{renderSliderBody()}</>}

            {addSliderVisible && <UrlShortenerForm onClose={() => { if (showAsOverlaySlider) { setAddSliderVisible(false) } else { setAddSliderVisible(false); onClose(); } }} getCreatedShortUrl={(shortUrl) => { updateCreatedUrlInStore(shortUrl); closeOverlaySidebar && closeOverlaySidebar() }} />}

        </>);
}

export default SelectUrl;